export default __webpack_public_path__ + "static/media/peacock-day.9f0899fc.jpg";